var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no-permissions-page"}},[_c('div',{staticClass:"text-center text-red-700"},[_c('b-icon',{attrs:{"icon":"low-vision","size":"is-large"}})],1),_c('div',{staticClass:"text-center text-xl mt-5"},[_vm._v(" Please reach out to administrator to set up your employee record and to get access! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }